import api, { toUserError } from './api'

export function normalizePartRequest(request) {
  if (!request) return null
  return {
    ...request,
    id: request.id || request._id,
    partId: request.partId ? String(request.partId) : '',
    partCode: request.partCode || '',
    partName: request.partName || '',
    itemName: request.itemName || request.partName || '',
    manufacturer: request.manufacturer || '',
    model: request.model || '',
    specification: request.specification || '',
    requestedQty: Number(request.requestedQty) || 0,
    unit: request.unit || '개',
    reason: request.reason || '',
    requesterId: request.requesterId ? String(request.requesterId) : '',
    requesterName: request.requesterName || '',
    requesterDepartment: request.requesterDepartment || '',
    status: request.status || 'REVIEWING',
    managerMemo: request.managerMemo || '',
    currentQuantity: request.currentQuantity == null ? null : Number(request.currentQuantity),
    source: request.source || 'MANUAL',
    batchId: request.batchId ? String(request.batchId) : '',
    supplier: request.supplier || '',
    vendorCode: request.vendorCode || '',
    purchaseUrl: request.purchaseUrl || '',
    unitPrice: request.unitPrice == null || request.unitPrice === '' ? null : Number(request.unitPrice),
    quotation: request.quotation?.fileName
      ? {
        fileName: request.quotation.fileName,
        mimeType: request.quotation.mimeType || '',
        fileSize: Number(request.quotation.fileSize) || 0,
        uploadedAt: request.quotation.uploadedAt || null,
      }
      : null,
    originalRequiredQuantity: request.originalRequiredQuantity == null ? null : Number(request.originalRequiredQuantity),
    shortageQuantity: request.shortageQuantity == null ? null : Number(request.shortageQuantity),
    suggestedRequestQuantity: request.suggestedRequestQuantity == null ? null : Number(request.suggestedRequestQuantity),
  }
}

export async function fetchPartRequestsPage(params = {}) {
  try {
    const query = {}
    Object.entries(params).forEach(([key, value]) => {
      if (value == null || value === '' || value === 'all') return
      query[key] = value
    })
    const { data } = await api.get('/part-requests', { params: query })
    const payload = data.data || {}
    const items = (payload.items || payload.requests || []).map(normalizePartRequest)
    const total = Number(payload.total ?? payload.count ?? items.length) || 0
    const limit = Number(payload.limit) || items.length || 20
    const page = Number(payload.page) || 1
    const totalPages = Number(payload.totalPages) || Math.max(1, Math.ceil(total / (limit || 1)))
    return { items, total, page, limit, totalPages }
  } catch (error) {
    throw toUserError(error)
  }
}

export async function fetchPartRequest(id) {
  try {
    const { data } = await api.get(`/part-requests/${id}`)
    return normalizePartRequest(data.data?.request)
  } catch (error) {
    throw toUserError(error)
  }
}

function requestFormData(payload, file) {
  const form = new FormData()
  Object.entries(payload).forEach(([key, value]) => {
    if (value == null) return
    form.append(key, value)
  })
  if (file) form.append('quotation', file)
  return form
}

export async function createPartRequest(payload, file) {
  try {
    const { data } = await api.post('/part-requests', requestFormData(payload, file), { timeout: 60000 })
    return normalizePartRequest(data.data?.request)
  } catch (error) {
    throw toUserError(error)
  }
}

export async function updatePartRequest(id, payload, file) {
  try {
    const { data } = await api.patch(`/part-requests/${id}`, requestFormData(payload, file), { timeout: 60000 })
    return normalizePartRequest(data.data?.request)
  } catch (error) {
    throw toUserError(error)
  }
}

export async function fetchPartRequestQuotation(id) {
  try {
    const { data } = await api.get(`/part-requests/${id}/quotation`)
    return data.data?.quotation
  } catch (error) {
    throw toUserError(error)
  }
}

export async function updatePartRequestStatus(id, payload) {
  try {
    const { data } = await api.put(`/part-requests/${id}/status`, payload)
    return normalizePartRequest(data.data?.request)
  } catch (error) {
    throw toUserError(error)
  }
}

export async function parseQuoteFile({ file, projectId }) {
  try {
    const form = new FormData()
    form.append('file', file)
    if (projectId) form.append('projectId', projectId)
    const { data } = await api.post('/purchase-request-import/parse', form, { timeout: 120000 })
    return data.data
  } catch (error) {
    throw toUserError(error)
  }
}

export async function confirmQuoteImport(payload) {
  try {
    const { data } = await api.post('/purchase-request-import/confirm', payload, { timeout: 30000 })
    return data.data
  } catch (error) {
    throw toUserError(error)
  }
}
